import { useMemo } from "react";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsOrgResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";
import { useGroups } from "../../../../Settings/General/OrganisationLevelGroups/context";
import { useOrgSettingsResourceLabel } from "../../../../../utils/hooks/useOrgSettingsResourceLabel";
import { useTranslation } from "react-i18next";

export const useGroupsFilters = () => {
	const { t } = useTranslation();
	const { groups } = useGroups();
	const renderOrgLevelResourceLabel = useOrgSettingsResourceLabel();

	return useMemo(() => {
		return groups.map((group) => ({
			id: group?.level?.replace("_", ""),
			Header: t("resource-worked", { resource: renderSettingsResourceLabel(group) }),
			canFilter: true,
			filter: "resource-select",
			Filter: (
				<ResourceSelect
					mode="multiple"
					resourcePath={`/${group?.id}/org-levels`}
					renderLabel={renderOrgLevelResourceLabel}
					valuePropName="id"
					getSearchFilters={getSettingsOrgResourceSearchFilters}
					hasSearch
				/>
			),
		}));
	}, [groups, renderOrgLevelResourceLabel, t]);
};
